export default (function (_ref) {
  var colors = _ref.colors;
  return {
    base: {
      marginTop: '9px',
      position: 'relative',
      fontSize: '13px',
      color: colors.error
    },
    base__noMargin: {
      margin: 0
    }
  };
});